import {decorate, observable} from 'mobx';
import {faCalculator} from '@fortawesome/free-solid-svg-icons';
import {BaseModel} from './base';

export class UnitOfMeasurementConversion extends BaseModel {
  static faIcon = faCalculator;
}

decorate(UnitOfMeasurementConversion, {
  id: observable,
  orderId: observable,
  sourceUnitOfMeasureId: observable,
  destinationUnitOfMeasureId: observable,
  numerator: observable,
  denominator: observable,
  createdAt: observable,
  createdBy: observable,
  updatedAt: observable,
  updatedBy: observable,
});
